// extracted by mini-css-extract-plugin
export default {"fab":"FloatingActionButton_fab__jhRSc","fabIcon":"FloatingActionButton_fabIcon__Wt49-"};